import axios from "axios";
import { TotalSumFunction, cheangeValue, setAllMonthRavenue } from "../../Reducer/RevenueSlice";
import { useDispatch, useSelector } from "react-redux";
import StaffKashier from "./StaffKashier";
import StaffCook from "./StaffCook";
import { setOpenMainMenu, setOpenRevenue, setOpenRevenueButtonsMenu, setOpenStaffManagment } from "../../Reducer/ModalSlice";
import StaffManager from "./StaffManager";
import StaffNoBonus from "./StaffNoBonus";
import PercentCityComponent from "./PercentCityComponent";
import StaffPercent from "./StaffPercent";
import ResultStaff from "./ResultStaff";
import ResultStaffPercent from "./ResultStaffPercent";
import { CiLock, CiUnlock } from "react-icons/ci";
import { MonthArrayAdd, changeBlockEditSelectedMonth } from "../../Reducer/MonthSlice";
import { CityArrayAdd } from "../../Reducer/CitySlice";
import { StaffArrayAdd, setStaffAllMonth } from "../../Reducer/StaffSlice";
import { clearPeriod } from "../../Reducer/PeriodSlice";
import ExportXlsx from "./ExportXlsx/ExportXlsx";
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5"
import { useState } from "react";
import { roleId } from "../Constants/app";
import StaffCookSecondGroup from "./StaffCookSecondGroup";

function RevenueCity() {

const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
const TotalSum = useSelector(state => state.RevenueSlice.TotalSum)
const FirstTotalSum = useSelector(state => state.RevenueSlice.FirstTotalSum)
const SecondTotalSum = useSelector(state => state.RevenueSlice.SecondTotalSum)
const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)

const SelectedCity = useSelector(state => state.CitySlice.SelectedCity)

const StaffSelectedCityArray = useSelector(state => state.StaffSlice.StaffSelectedCityArray)

const Period = useSelector(state => state.PeriodSlice.Period)

const User = useSelector(state => state.UserSlice.User)
const Server = useSelector(state => state.UserSlice.Server)

const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)
const WeekDay = useSelector(state => state.MonthSlice.WeekDay)

const OpenRevenueButtonsMenu = useSelector(state => state.ModalSlice.OpenModal.OpenRevenueButtonsMenu)

const [CancelTouch, setCancelTouch] = useState(false);
const [isLoading, setLoading] = useState(true);

const dispatch = useDispatch()

const handleExitToTheMainMenu = async (event) => {
  if(event.type === 'touchend')
    event.preventDefault()

  setLoading(false);
  await StaffSelectedCityArray.map((el) => {
    var HoursArray = []
    var Additional = String(el.FirstBonus.Value + '_' + el.FirstFine.Value + '_' + el.SecondBonus.Value + '_' + el.SecondFine.Value)
    el.Hours.map((a) => {
        HoursArray = String(HoursArray) + String(a.Value) + '_'
        return(a)
    })
    HoursArray = HoursArray.slice(0, -1);
    axios.put(Server + "staff/" + el.id, {
        FIO: el.FIO,
    }, {
      headers: {
        Authorization: 'Bearer ' + User.jwt,
      },
    })

    axios.put(Server + "staffofthemonths/" + el.idHourses, {
      Hours: HoursArray,
      Additional: Additional,
      Shift: el.Shift,
      Rate: el.Rate,
      Prize: el.Prize,
      SecondShift: el.SecondShift,
      SecondRate: el.SecondRate,
      SecondPrize: el.SecondPrize
  }, {
    headers: {
      Authorization: 'Bearer ' + User.jwt,
    },
  })
    return(el)
  })

var Revenue = []
await RevenueArray.map((a) =>{
  Revenue = String(Revenue) + String(a.Value) + '_'
  
  return(a)
})
  Revenue = Revenue.slice(0, -1);
  var PercentArray = PercentCity.Kashier + "_" + PercentCity.Cook + "_" + PercentCity.PrizeMinSum + '_' + PercentCity.PrizeSumKashier + '_' + PercentCity.PrizeSumCook + '_' + PercentCity.RatioRevenue
  await axios.put(Server + "citiesrevenues/" + SelectedCity.idRevenue, {
    Revenue: Revenue,
    Percent: PercentArray
  }, {
    headers: {
      Authorization: 'Bearer ' + User.jwt,
    },
  })

  var CityArrayChecked = []
        var CityCheck 
            await axios.get(Server + 'cities?_limit=-1', {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                }
            })
            .then((response) => {
                if([roleId.admin, roleId.operatingDirector].includes(User.user.role.id)|| User.user.idCity === 'all')
                    {
                        dispatch(CityArrayAdd(response.data))
                    }
                    else
                    {
                        CityCheck = response.data
                    }
                })
    
        if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && User.user.idCity !== 'all')
        {
            await User.user.idCity.map((el) => {
                CityCheck.map((a) => {
                    if(parseInt(a.id) === parseInt(el))
                    {
                        CityArrayChecked.push(a)
                    }
                    return(a)
                })
                return(el)
            })
            await dispatch(CityArrayAdd(CityArrayChecked))
        }
              
        axios.get(Server + "staff?_limit=-1", {
          headers: {
              Authorization: 'Bearer ' + User.jwt,
          }
      })
      .then((responseStaff) => {
            dispatch(StaffArrayAdd(responseStaff.data))             
        });

        axios.get(Server + 'months?_limit=-1&_sort=id:DESC', {
          headers: {
              Authorization: 'Bearer ' + User.jwt,
          }
      })
      .then((responseMonth) => {
          dispatch(MonthArrayAdd(responseMonth.data))
        })

        axios.get(Server + 'citiesrevenues?_limit=-1', {
          headers: {
              Authorization: 'Bearer ' + User.jwt,
          }
      })
      .then((responseRevenue) => {
          dispatch(setAllMonthRavenue(responseRevenue.data))
        })

        axios.get(Server + 'staffofthemonths?_limit=-1', {
          headers: {
              Authorization: 'Bearer ' + User.jwt,
          }
      })
      .then((responseStafffAllMonth) => {
          dispatch(setStaffAllMonth(responseStafffAllMonth.data))
        })
  
  
  await dispatch(TotalSumFunction({MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
  await dispatch(clearPeriod())
  await dispatch(setOpenMainMenu(true))
  await dispatch(setOpenRevenue(false))
}



const handleBlockEdit = (event) => {
  if(event.type === 'touchend')
    event.preventDefault()

  if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id))
    {
      if(SelectedMonth.BlockEdit !== true)
      {
        dispatch(changeBlockEditSelectedMonth(true))
        axios.put(Server + 'months/' + SelectedMonth.id, {
          BlockEdit: true
        }, {
          headers: {
            Authorization: 'Bearer ' + User.jwt,
          },
        })

      }
      else
      {
        dispatch(changeBlockEditSelectedMonth(false))
        axios.put(Server + 'months/' + SelectedMonth.id, {
          BlockEdit: false
        }, {
          headers: {
            Authorization: 'Bearer ' + User.jwt,
          },
        })
      }
    }
    else
    {
      alert('У вас нет прав для данного действия')
    }
}

const handleClickSaveButton = (event) => {
  if(event.type === 'touchend')
    event.preventDefault()

  document.getElementById('SaveButton').classList.add('loader')
  document.getElementById('SaveButtonFake').classList.add('loader')
  StaffSelectedCityArray.map((el) => {
    var HoursArray = []
    var Additional = String(el.FirstBonus.Value + '_' + el.FirstFine.Value + '_' + el.SecondBonus.Value + '_' + el.SecondFine.Value)
    el.Hours.map((a) => {
        HoursArray = String(HoursArray) + String(a.Value) + '_'
        return(a)
    })
    HoursArray = HoursArray.slice(0, -1);
    axios.put(Server + "staff/" + el.id, {
      FIO: el.FIO,
    }, {
      headers: {
        Authorization: 'Bearer ' + User.jwt,
      },
    })

    axios.put(Server + "staffofthemonths/" + el.idHourses, {
      Hours: HoursArray,
      Additional: Additional,
      Shift: el.Shift,
      Rate: el.Rate,
      Prize: el.Prize,
      Hidden: el.Hidden,
      SecondShift: el.SecondShift,
      SecondRate: el.SecondRate,
      SecondPrize: el.SecondPrize
    }, {
      headers: {
        Authorization: 'Bearer ' + User.jwt,
      },
    })
    
    return(el)
  })

  var Revenue = []
  RevenueArray.map((a) =>{
    Revenue = String(Revenue) + String(a.Value) + '_'
    
    return(a)
  })
    Revenue = Revenue.slice(0, -1);
    var PercentArray = PercentCity.Kashier + "_" + PercentCity.Cook + "_" + PercentCity.PrizeMinSum + '_' + PercentCity.PrizeSumKashier + '_' + PercentCity.PrizeSumCook + '_' + PercentCity.RatioRevenue + '_' + PercentCity.CookSecondGroup + '_' + PercentCity.PrizeSumCookSecondGroup
    axios.put(Server + "citiesrevenues/" + SelectedCity.idRevenue, {
      Revenue: Revenue,
      Percent: PercentArray
    }, {
      headers: {
        Authorization: 'Bearer ' + User.jwt,
      },
    })
    .then(() => {
      document.getElementById('SpinSaveButtonFake').classList.add('Saved')
      document.getElementById('SucsessSaveIcon').classList.add('Saved')
      setTimeout(() => {
        document.getElementById('SpinSaveButtonFake').classList.remove('Saved')
        document.getElementById('SucsessSaveIcon').classList.remove('Saved')
        document.getElementById('SaveButton').classList.remove('loader')
        document.getElementById('SaveButtonFake').classList.remove('loader')
      }, 500)
    })
    .catch(() => {
      document.getElementById('SpinSaveButtonFake').classList.add('Saved')
      document.getElementById('FalseSaveIcon').classList.add('Saved')
      alert('Ошибка сохранения. Повторите попытку.')
      setTimeout(() => {
        document.getElementById('SpinSaveButtonFake').classList.remove('Saved')
      document.getElementById('FalseSaveIcon').classList.remove('Saved')
        document.getElementById('SaveButton').classList.remove('loader')
        document.getElementById('SaveButtonFake').classList.remove('loader')
      }, 500)
    })
}

  const renderWeekDay = (id) => {
    if(WeekDay + id === 1 || WeekDay + id === 8 || WeekDay + id === 15 || WeekDay + id === 22 || WeekDay + id === 29 || WeekDay + id === 36)
      return 'Пн.';

    if(WeekDay + id === 2 || WeekDay + id === 9 || WeekDay + id === 16 || WeekDay + id === 23 || WeekDay + id === 30 || WeekDay + id === 37)
      return 'Вт.';

    if(WeekDay + id === 3 || WeekDay + id === 10 || WeekDay + id === 17 || WeekDay + id === 24 || WeekDay + id === 31 || WeekDay + id === 38)
      return 'Ср.';

    if(WeekDay + id === 4 || WeekDay + id === 11 || WeekDay + id === 18 || WeekDay + id === 25 || WeekDay + id === 32 || WeekDay + id === 39)
      return 'Чт.';

    if(WeekDay + id === 5 || WeekDay + id === 12 || WeekDay + id === 19 || WeekDay + id === 26 || WeekDay + id === 33 || WeekDay + id === 40)
      return 'Пт.';

    if(WeekDay + id === 6 || WeekDay + id === 13 || WeekDay + id === 20 || WeekDay + id === 27 || WeekDay + id === 34  || WeekDay + id === 41)
      return 'Сб.';

    if(WeekDay + id === 0 || WeekDay + id === 7 || WeekDay + id === 14 || WeekDay + id === 21 || WeekDay + id === 28 || WeekDay + id === 35  || WeekDay + id === 42)
      return 'Вс.';    
  }

  if (!isLoading)
    return (
      <div
      className="ModalGlobalDiv"
      >
          <div
          className="BigSpin"
          />
      </div>
    );
  
  return (
    <div className="GlobalDivRevenueCity">
      <div
      className="DivFlex"
      >
        <div
        className="RevenueCityLongDiv"
        >
          {SelectedCity.id !== 0 ? SelectedCity.Name : 'Город не выбран'}
        </div>
      
        <div
        className={OpenRevenueButtonsMenu ? "RevenueUpButtonsDiv" : "RevenueUpButtonsDiv Close"}
        >
          <button
          className="RevenueMenuButton"
          onClick={handleExitToTheMainMenu}
          onTouchStart={() => {
            setCancelTouch(false)
          }}
          onTouchMove={() => {
              setCancelTouch(true)
          }}
          onTouchCancel={() => {
              setCancelTouch(true)
          }}
          onTouchEnd={(event) => {
            event.preventDefault()
            if(!CancelTouch)
              handleExitToTheMainMenu(event)
          }}
          >
            Главное меню
          </button>
          <button
          className="RevenueMenuButton"
          onClick={(() => {
            dispatch(setOpenStaffManagment(true))
          })}
          onTouchStart={() => {
            setCancelTouch(false)
          }}
          onTouchMove={() => {
              setCancelTouch(true)
          }}
          onTouchCancel={() => {
              setCancelTouch(true)
          }}
          onTouchEnd={((event) => {
            event.preventDefault()
            if(!CancelTouch)
            {
              dispatch(setOpenStaffManagment(true))
              dispatch(setOpenRevenue(false))
            }
          })}
          >
            Управление
          </button>
          {!Period.PeriodOn && <ExportXlsx/>}
        </div>

      <div
      className={OpenRevenueButtonsMenu ? "BlackoutMainMenuOptionsDiv" : "BlackoutMainMenuOptionsDiv Close"}
      onClick={(() => {
          dispatch(setOpenRevenueButtonsMenu(false))
      })}
      onTouchStart={() => {
        setCancelTouch(false)
      }}
      onTouchMove={() => {
          setCancelTouch(true)
      }}
      onTouchCancel={() => {
          setCancelTouch(true)
      }}
      onTouchEnd={((event) => {
          event.preventDefault()
          if(!CancelTouch)
            dispatch(setOpenRevenueButtonsMenu(false))
      })}
      />
      
     </div>
     
      <div
      className="RevenueCityMainDiv"
      >
        <div
        className="RevenueMounthDiv"
        >
          <div>
            {SelectedMonth.id === 0 ? 'Месяц не выбран' : SelectedMonth.Name}
          </div>
          <button
          className="RevenueMounthIconDiv"
          onClick={handleBlockEdit}
          onTouchStart={() => {
            setCancelTouch(false)
          }}
          onTouchMove={() => {
              setCancelTouch(true)
          }}
          onTouchCancel={() => {
              setCancelTouch(true)
          }}
          onTouchEnd={(event) => {
            event.preventDefault()
            if(!CancelTouch)
              handleBlockEdit(event)
          }}
          >
            {SelectedMonth.id !== 0 && SelectedMonth.BlockEdit !== true ? 
            <CiUnlock/> 
            : 
            <CiLock/>
            }
          </button>
            
        </div>

        {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && RevenueArray.length > 0 && RevenueArray.map((el) => 
        el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay && 
        <div
        key={el.id}
        className="DateDivRevenue"
        id={'DateDivRevenue' + el.id}
        >
          {parseInt(el.id) + 1}
        </div>
        )}
        
        {Period.MinDay < 14 &&
        <div
        className="DivFlex"
        >
          <div
          className="RevenueTotalDiv"
          >
            Итого
          </div>

          <div
          className={Period.MaxDay > 15 ? "RevenueMounthPartBetweenDiv" : "RevenueMounthPartBetweenDiv Short"}
          >      
          </div>

        </div>
        }
            
        {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && RevenueArray.length > 0 && RevenueArray.map((el) => 
        el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay && 
        <div
        key={el.id}
        className="DateDivRevenue"
        id={'DateDivRevenue' + el.id}
        >
          {parseInt(el.id) + 1}
        </div>
        )}
        
        <div
        className="DivFlex"
        >
          
          {Period.MaxDay > 15 &&
          <div
          className="RevenueTotalDiv"
          >
            Итого
          </div>
          }
          
          
          {Period.MaxDay > 15 &&
          <div
          className="RevenueMounthPartBetweenDiv Short"
          >
          </div>
          }
          
          {Period.MinDay < 14 && Period.MaxDay > 15 &&
          <div
          className="RevenueTotalDiv TotalMonth"
          >
            {!Period.PeriodOn ? 'Итого за месяц' : 'Итого за период'}
          </div>
          }

        </div>
        
      </div>
      
    

      {SelectedMonth.id !== 0 && SelectedCity.id !== 0 && <div
      className="RevenueCityMainDiv"
      >
        <div
        className="RevenueCityLongDiv"
        >
            День недели
        </div>
        {RevenueArray.length > 0 && RevenueArray.map((el) => 
        el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay && 
        <div
        key={el.id}
        className="DateDivRevenue"
        id={'DateDivRevenue' + el.id}
        >
          {renderWeekDay(el.id)}
        </div>
        )}
                    
            
        {Period.MinDay < 14 &&
        <div
        className={Period.MaxDay > 15 ? "RevenueWeekDayMounthPartBetweenDiv" : "RevenueWeekDayMounthPartBetweenDiv PeriodMin"}
        >
              
        </div>
        }
        
        {RevenueArray.length > 0 && RevenueArray.map((el) => 
        el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay && 
        <div
        key={el.id}
        className="DateDivRevenue"
        id={'DateDivRevenue' + el.id}
        >
          {renderWeekDay(el.id)}
        </div>
        )}        
        
        {Period.MaxDay > 15 &&
        <div
        className={Period.MinDay < 14 ? "RevenueWeekDayMounthPartBetweenDiv Short" : 'RevenueWeekDayMounthPartBetweenDiv PeriodMin'}
        >
          
        </div>
        }
        
        
      </div>
    }

     {SelectedMonth.id !== 0 && SelectedCity.id !== 0 && <div
      className="RevenueCityMainDiv"
      >
        <div
        className="RevenueCityLongDiv"
        >
            {"Выручка (руб.)"}
        </div>
        {RevenueArray.length > 0 && RevenueArray.map((el) => 
        el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay && 
        <input
        key={el.id}
        className="inputRevenue"
        id={'inputRevenue' + el.id}
        type="Number"
        tabIndex={0}
        value={el.Value}
        data-value={el.Value}
        onTouchStart={() => {
          setCancelTouch(false)
        }}
        onTouchMove={() => {
            setCancelTouch(true)
        }}
        onTouchCancel={() => {
            setCancelTouch(true)
        }}
        onTouchEnd={(() => {
          if(!CancelTouch)
            document.getElementById('inputRevenue' + el.id).focus()
        })}
        onFocus={(() =>{
          document.getElementById('inputRevenue' + el.id).classList.add('Selected')
          document.getElementById('DateDivRevenue' + el.id).classList.add('Select')
        })}
        onBlur={(() => {
            document.getElementById('inputRevenue' + el.id).classList.remove('Selected')
            document.getElementById('DateDivRevenue' + el.id).classList.remove('Select')
        })}
        onChange={((e) => {
          if(SelectedMonth.BlockEdit !== true)
            if(e.target.value !== '' && e.target.value > -1)
              {
                dispatch(cheangeValue({id: el.id, Value: parseFloat(e.target.value)}))
                dispatch(TotalSumFunction({MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
              }
              else
              {
                dispatch(cheangeValue({id: el.id, Value: 0}))
                dispatch(TotalSumFunction({MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
              }
            
        })}
        />
      )}
              {Period.MinDay < 14 &&
              <div
              className="DivFlex"
              >
                <div
                className="RevenueTotalDiv"
                >
                    {FirstTotalSum && FirstTotalSum.replace('.', ',') + ' руб.'}
                </div>
                <div
                className={Period.MaxDay > 15 ? "RevenueMounthPartBetweenDiv" : "RevenueMounthPartBetweenDiv Short"}
                >
                </div>
              </div>
              }

            {RevenueArray.length > 0 && RevenueArray.map((el) => 
            el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay && 
            <input
            key={el.id}
            className="inputRevenue"
            id={'inputRevenue' + el.id}
            type="Number"
            tabIndex={0}
            value={el.Value}
            data-value={el.Value}
            onTouchStart={() => {
              setCancelTouch(false)
            }}
            onTouchMove={() => {
                setCancelTouch(true)
            }}
            onTouchCancel={() => {
                setCancelTouch(true)
            }}
            onTouchEnd={(() => {
              if(!CancelTouch)
                document.getElementById('inputRevenue' + el.id).focus()
            })}
            onFocus={(() =>{
              document.getElementById('inputRevenue' + el.id).classList.add('Selected')
              document.getElementById('DateDivRevenue' + el.id).classList.add('Select')
            })}
            onBlur={(() => {
                document.getElementById('inputRevenue' + el.id).classList.remove('Selected')
                document.getElementById('DateDivRevenue' + el.id).classList.remove('Select')
            })}
            onChange={((e) => {
              if(SelectedMonth.BlockEdit !== true)
                if(e.target.value !== '' && e.target.value > -1)
                  {
                    dispatch(cheangeValue({id: el.id, Value: parseFloat(e.target.value)}))
                    dispatch(TotalSumFunction({MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
                  }
                  else
                  {
                    dispatch(cheangeValue({id: el.id, Value: 0}))
                    dispatch(TotalSumFunction({MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
                  }
                
            })}
            />
          )}
        
        {Period.MaxDay > 15 &&
        <div
        className="DivFlex"
        >
          <div
          className="RevenueTotalDiv"
          >
            {SecondTotalSum && SecondTotalSum.replace('.', ',') + " руб."}
          </div>
          <div
          className="RevenueMounthPartBetweenDiv Short"
          >
                
          </div>
        </div>
        }
        
        
        {Period.MinDay < 14 && Period.MaxDay > 15 &&
        <div
        className="RevenueTotalDiv"
        >
          {TotalSum && TotalSum.replace('.', ',') + " руб."}
        </div>
        }
        
      </div>
      }

      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <StaffKashier/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <StaffCook/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <StaffCookSecondGroup/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <StaffManager/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <StaffNoBonus/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <ResultStaff/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <ResultStaffPercent/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <PercentCityComponent/> }
      {SelectedCity.id !== 0 && SelectedMonth.id !== 0 && <StaffPercent/> }
      

      {SelectedCity.id !== 0 &&  SelectedMonth.id !== 0 && 
      <button
      className="SaveButton"
      id='SaveButton'
      onClick={handleClickSaveButton}
      onTouchStart={() => {
        setCancelTouch(false)
      }}
      onTouchMove={() => {
          setCancelTouch(true)
      }}
      onTouchCancel={() => {
          setCancelTouch(true)
      }}
      onTouchEnd={(event) => {
        event.preventDefault()
        if(!CancelTouch)
          handleClickSaveButton(event)
      }}
      >
        Сохранить
      </button>
      }

      {SelectedCity.id !== 0 &&  SelectedMonth.id !== 0 && 
      <button
      className="SaveButtonFake"
      id='SaveButtonFake'
      >
        <div id="SpinSaveButtonFake" className="SpinSaveButtonFake"/>
        <FaCheck id='SucsessSaveIcon' className="SucsessSaveIcon"/>
        <IoClose id="FalseSaveIcon" className="SucsessSaveIcon"/>
      </button>
      }
    </div>
  )
}

export default RevenueCity;
